import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import styles from "./Login.module.css";
import Logo from "../../components/Logo";
import * as yup from "yup";
import IcEye from "../../components/Svg/IcEye";
import api from "../../services/api";
import { Form } from "react-bootstrap";
import Button from "../../components/Button";

const createSchema = yup.object().shape({
  password_confirm: yup
    .string()
    .oneOf([yup.ref("password"), null], "As Senhas não são iguais. Tente novamente.")
    .required("Por favor, confirme sua Senha."),
  password: yup.string().required("Por favor, insira uma Nova Senha."),
});

export default function PasswordChange() {
  const [loading, setloading] = useState(false);
  const [password, setPassword] = useState("");
  const [password_confirm, setPasswordConfirm] = useState("");
  const [, setLoginError] = useState("");
  const [loginSucess, setloginSucess] = useState("");
  const [, setdisableButtons] = useState(false);
  const [formSucess, setformSucess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  async function changePassword(password) {
    const query = new URLSearchParams(window.location.search);
    const token = query.get("code");
    const userType = query.get("t");
    let apiUrl = "";
    let redirectUrl = "";
    switch (userType) {
      case "g": //gestor
        apiUrl = "forgot-password";
        redirectUrl = "/gestor";
        break;
      case "f": //formando
      default:
        apiUrl = "forgot-password-trainee";
        redirectUrl = "/";
        break;
    }

    setdisableButtons(true);
    try {
      setloading(true);
      await api.put(apiUrl, {
        token: token,
        password: password,
        password_confirmation: password_confirm,
      });
      setloginSucess("Senha modificada com sucesso!");
      setformSucess(true);
      setTimeout(function () {
        window.location.replace(redirectUrl);
      }, 2000);
    } catch (err) {
      setloading(false);
      setLoginError("Houve algum problema, tente mais tarde.");
    }
  }

  async function handleSubmit() {
    setLoginError("");

    createSchema
      .validate({
        password: password,
        password_confirm: password_confirm,
      })
      .then(function () {
        changePassword(password);
      })
      .catch(function (err) {
        let inputError = document.querySelector(`[name='${err.path}']`);
        let inputErrorParent = inputError.parentElement.parentElement;
        inputErrorParent.setAttribute("data-status", "error");
        inputError.addEventListener("focus", () => {
          inputErrorParent.setAttribute("data-status", "");
        });
        setLoginError(err.message);
      });
  }

  return (
    <div className={`${styles.wrapLogin} ${styles._formando}`}>
      <div className="text-center">
        <Logo />
        <p className="mt-3">
          Insira e confirme sua <b>Nova Senha</b>
        </p>
      </div>
      <Form>
        {!formSucess ? (
          <>
            <Form.Group className={`${styles.inputBox} lince-input`}>
              <p className="m-0">Nova Senha</p>
              <div className="lince-input__text passwordField position-relative">
                <Form.Control
                  type={showPassword ? `text` : `password`}
                  onChange={e => setPassword(e.target.value)}
                  name="password"
                  value={password}
                />
                <i className={`showPassword ${styles.showPassword}`} onClick={e => setShowPassword(!showPassword)}>
                  <IcEye />
                </i>
              </div>
            </Form.Group>
            <Form.Group className={`${styles.inputBox} lince-input mt-2`}>
              <p className="m-0">Confirme a Nova Senha</p>
              <div className="lince-input__text passwordField position-relative">
                <Form.Control
                  type={showPassword ? `text` : `password`}
                  onChange={e => setPasswordConfirm(e.target.value)}
                  name="password_confirm"
                  value={password_confirm}
                />
                <i className={`showPassword ${styles.showPassword}`} onClick={e => setShowPassword(!showPassword)}>
                  <IcEye />
                </i>
              </div>
            </Form.Group>
            <Button
              color="primary"
              loading={loading}
              onClick={() => {
                handleSubmit();
              }}
              className="w-100 mt-4 p-4"
            >
              Mudar Senha
            </Button>
          </>
        ) : (
          <p className={styles.formMsg}>
            <i className={styles.success_ico}>
              <FaCheck color="#8032A1" size={12} />
            </i>
            {loginSucess}
          </p>
        )}
      </Form>
    </div>
  );
}
